<template >
 <v-dialog v-model="show_dialog " persistent max-width="700px" height="400px" >
  <v-card class="dialog_user_pay">
    <!-- =>{{show_dialog}} -->
    <!-- <v-card-title> {{pay_type}} -{{total_money}} - {{recv_money}}</v-card-title> -->
    <v-card-text>
         <v-tabs icons-and-text  dark color="cyan" v-model="pay_type">
            <v-tabs-slider color="red"></v-tabs-slider>
            <v-tab href="#cash"   v-show="enable_tab('cash')"> 现金/银行卡 <v-icon>ti-money</v-icon> </v-tab> 
            <v-tab href="#weixin" v-show="enable_tab('weixin')"> 微信     <v-icon>ti-themify-favicon-alt</v-icon> </v-tab>
            <v-tab href="#alipay" v-show="enable_tab('alipay')"> 支付宝    <v-icon>ti-reddit</v-icon> </v-tab>
            <v-tab href="#mall"   v-show="enable_tab('mall')"> 商场代收    <v-icon>ti-home</v-icon> </v-tab>
            
            <v-tab-item id="cash" v-show="enable_tab('cash')"> 
                <v-card flat>
                    <v-card-title> 
                        <h2>
                            现金/银行卡支付
                            <span class="red--text">(总金额:{{total_money.toFixed(2)}})</span>
                            <span class="red--text" v-if="use_prepay>0">(会员卡支付:{{use_prepay.toFixed(2)}})</span>
                        </h2> 
                        
                        
                    </v-card-title>
                    <v-card-text>
                        <v-layout row>
                          <v-flex xs4>
                            <v-card-title><h3>收取现金</h3></v-card-title>
                          </v-flex>
                          <v-flex xs8>
                            <v-text-field 
                                ref="in_cash"
                                class="big_input"
                                clearable
                                @keyup.13="enter_cash('cash')"
                                v-model.number= "recv_money"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout row>
                          <v-flex xs4>
                            <v-card-title><h3>银行卡号</h3></v-card-title>
                          </v-flex>
                          <v-flex xs8>
                            <v-text-field 
                                ref="in_bank"
                                class="big_input"
                                clearable
                                @keyup.13="enter_cash('bank')"
                                v-model= "bank_id"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>

                    </v-card-text>
                </v-card>
            </v-tab-item>
            <v-tab-item id="weixin" v-show="enable_tab('weixin')"> 
                <v-card flat>
                    <v-card-title> 
                        <h2>微信扫码支付
                            <span class="red--text">(总金额:{{total_money.toFixed(2)}})</span>
                            <span class="red--text" v-if="use_prepay>0">(会员卡支付:{{use_prepay.toFixed(2)}})</span>
                        </h2> 
                        <v-spacer></v-spacer>
                        <v-switch color="error" label="部分现金" v-model="mix_cash"></v-switch>
                    </v-card-title>
                    <v-card-text>
                        <v-layout row v-if="mix_cash">  
                          <v-flex xs4>
                            <v-card-title><h3>收取现金</h3></v-card-title>
                          </v-flex>
                          <v-flex xs8>
                                <v-text-field 
                                    ref="weixin_cash"
                                    class="big_input"
                                    clearable
                                    v-model.number= "recv_money"
                                ></v-text-field>

                          </v-flex>
                        </v-layout>
                        <v-layout row>
                          <v-flex xs4>
                            <v-card-title><h3>微信扫码</h3></v-card-title>
                          </v-flex>
                          <v-flex xs8>
                            <v-text-field 
                                clearable
                                class="big_input"
                                ref="in_weixin"
                                v-model= "auth_code"
                                @keyup.13="do_pay()"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>

                    </v-card-text>

                </v-card>
            </v-tab-item>
            <v-tab-item id="alipay" v-show="enable_tab('alipay')"> 
                <v-card flat>
                    <v-card-title> 
                        <h2>支付宝扫码支付
                            <span class="red--text">(总金额:{{total_money.toFixed(2)}})</span>
                            <span class="red--text" v-if="use_prepay>0">(会员卡支付:{{use_prepay.toFixed(2)}})</span>
                        </h2> 
                        <v-spacer></v-spacer>
                        <v-switch color="error" label="部分现金" v-model="mix_cash"></v-switch>
                    </v-card-title>
                    <v-card-text>
                        <v-layout row v-if="mix_cash">  
                          <v-flex xs4>
                            <v-card-title><h3>收取现金</h3></v-card-title>
                          </v-flex>
                          <v-flex xs8>
                                 <v-text-field 
                                    ref="alipay_cash"
                                    class="big_input"
                                    clearable
                                    v-model.number= "recv_money"
                                ></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout row>
                          <v-flex xs4>
                            <v-card-title><h3>支付宝扫码</h3></v-card-title>
                          </v-flex>
                          <v-flex xs8>
                            <v-text-field 
                                clearable
                                ref="in_alipay"
                                class="big_input"
                                v-model= "auth_code"
                                @keyup.13="do_pay()"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-tab-item>
            <v-tab-item id="mall" v-show="enable_tab('alipay')"> 
                <v-card flat>
                     <v-card-title> 
                        <h2>商场代收:
                            <span class="red--text">(总金额:{{total_money.toFixed(2)}})</span>
                            <span class="red--text" v-if="use_prepay>0">(会员卡支付:{{use_prepay.toFixed(2)}})</span>
                        </h2>
                        <v-spacer></v-spacer>
                        <v-switch color="error" label="部分现金" v-model="mix_cash"></v-switch> 
                    </v-card-title>
                    <v-card-text>
                        <v-layout row v-if="mix_cash">  
                          <v-flex xs4>
                            <v-card-title><h3>收取现金</h3></v-card-title>
                          </v-flex>
                          <v-flex xs8>
                                 <v-text-field  
                                    class="big_input"
                                    ref="mall_cash"
                                    clearable
                                    v-model.number= "recv_money"
                                ></v-text-field>
                          </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-tab-item>
            
          </v-tabs>

    <h2 v-if="cash_msg" class="red--text">{{cash_msg}} </h2>

    </v-card-text>
    
    <v-card-actions>
        <!-- <v-card-text>{{err_msg}}</v-card-text> -->
        <v-switch color="error" label="淘宝订单" v-model="taobao" v-if="enable_types.indexOf('taobao')>-1"></v-switch>
        <v-spacer></v-spacer>
        <!-- <v-btn fab dark large color="green">
          <v-icon dark>done</v-icon>
        </v-btn> -->
      <v-btn class="btn-" @click.stop="show_dialog=false;callback&&callback(null)">取消</v-btn>
      <v-btn
          :loading="creating"
          :disabled="creating"
          color="info"
          @click.native.stop="do_pay">
          确定
          <span slot="loader" class="custom-loader">
            Loading...
          </span>
      </v-btn>
    </v-card-actions>

  </v-card>
</v-dialog>       
        
   
</template>

<script>
// import * as sale_api from "@/api/module/sale"   
import prompt_dlg from '../mixin/mix_prompt_dlg'

// import {vip_recharge} from "@/api/module/vip"
// import {selectoption} from "@/api/module/select_options"    
export default {
    //template:``,['mall', 'taobao', 'mix', 'cash','weixin','alipay']
    name: '',
    props:{
        // recharge:
        // total_money:{ type:Number,default:0},
        // order_id   :{ type:String,default:''},
    },
    mixins:[prompt_dlg],
    watch:{
        recv_money(val,old){
            // debugger
            if(val == null) return this.recv_money =0;
        },
        show_dialog(val){
            if(val){
                this.init_dialog();
                this.$nextTick(_=>this.$refs["in_cash"].focus());
                console.log("watch:show_dialog=",val)
            } 
        },
        pay_type(val,old){
            // if(val != 'cash')
            {
                this.recv_money = 0;
                this.bank_id    = '';
                this.mix_cash  = false;
            }
            this.auth_code  = ''
            // console.log("CHANGE pay_type",val,this.$refs["in_"+val])
            if(['cash','weixin','alipay'].indexOf(val)>=0){
                this.$nextTick(_=>this.$refs["in_"+val].focus());
            }
        },
        mix_cash(val){
            if(val){
                if(this.pay_type == 'weixin')
                    this.$nextTick(()=>{
                        this.$refs['weixin_cash'].focus()
                    })
                else if(this.pay_type == 'alipay')
                    this.$nextTick(()=>{
                        this.$refs['alipay_cash'].focus()
                    })
                else if(this.pay_type == 'mall')
                    this.$nextTick(()=>{
                        this.$refs['mall_cash'].focus()
                    })

                
            }
        }
    },
    computed:{
        show_dialog:{
            get(){
                return this.$store.state.dialog.show_user_pay_dialog;
            },
            set(val){
                // if(!val){
                //     this.init_dialog();
                // }
                if(val){
                    if(this.show_dialog == 'pay_order' || typeof(this.show_dialog) =='object'){
                        this.creating = false;
                        return;
                    }
                }
                this.$store.commit('SHOW_DIALOG_USER_PAY',val)
            }
        },
        enable_types(){
            return this.show_dialog.types?
                this.show_dialog.types:['cash','weixin','alipay','mall','taobao'];
        },
        config(){
            if(typeof(this.show_dialog) == 'boolean' && !this.show_dialog) 
                return {money:0,use_prepay:0};
            return this.show_dialog;
        },
        total_money(){
            return this.config.money;
        },
        use_prepay(){
            return this.config.prepay_money;
        },
        callback(){
            return this.show_dialog.callback;
        },
        cash_msg:function(){
            var str_err = "";
            if(this.pay_type =='cash'){
                if (this.recv_money == 0 && this.total_money != 0){
                    if(this.bank_id =='')
                        return str_err ="请输入实收现金或银行卡末4位！"
                    if(this.bank_id.length != 4){
                        return str_err ="请输入银行卡末4位！"
                    }
                    return str_err ="银行卡消费:" + this.total_money.toFixed(2);
                }
                else if (this.recv_money +0.009< this.total_money) {
                    if(this.bank_id =='')
                        return str_err ="实收现金不足"
                    if(this.bank_id.length != 4){
                        return str_err ="混合收银，请输入银行卡末4位！"
                    }
                    return str_err ="混合收银:现金"+this.recv_money.toFixed(2) +"  银行卡:"+ (this.total_money-this.recv_money).toFixed(2)
                }
                else if (this.recv_money >= this.total_money + 100) {
                    return "收取的现金不应多于商品总金额+100元!";
                }
                return `找零:${(this.recv_money - this.total_money).toFixed(2)} 元`
            }else if(this.pay_type =='weixin' ||this.pay_type =='alipay'){
                if(this.recv_money > 0){
                    str_err = "收取现金:" + this.recv_money.toFixed(2);
                }
                if(this.auth_code == '')
                    return str_err+=" 请输入付款码";
            }else if(this.pay_type =='mall'){
                if(this.mix_cash) {
                    if(this.recv_money > this.total_money){
                        return "收取的现金超过总金额"
                    }
                    str_err = "收取现金:" + this.recv_money.toFixed(2);
                }
                str_err + "商场代收:"+(this.total_money -  this.recv_money).toFixed(2)+"元";
            }
            return str_err;
        }
    },
    methods:{
        enable_tab(type){
            if(this.enable_types.indexOf(type)<0) return false;
            if(type == 'mall' && this.config.type == 'recharge') return false
            return true
        },
        enter_cash(type){
            if(type=='cash'){
                if(this.recv_money > this.total_money){
                    this.do_pay()
                }else{
                    this.$nextTick(()=>{
                        this.$refs['in_bank'].focus()
                    })
                }
            }else if(type=='bank'){
                if(this.bank_id.length ==4) return this.do_pay();
                if(this.bank_id.length == 0)return this.$refs['in_cash'].focus();
                this.$refs['in_bank'].select()
            }
        },
        pay_detail(){
            /*
            this.pay_type   = 'cash';
            this.where      = "store";
            this.bank_id    = "";
            this.auth_code  = "";
            this.recv_money = 0;
            this.taobao     = false;
            this.err_msg    = "";
            */
            let pay_type = this.pay_type;
            if(pay_type =='cash'/*&& this.recv_money ==0 */&& this.bank_id.length == 4){
                pay_type = 'bank';
            }
            let detail = {
                total_money: this.total_money,
                pay_type   : pay_type,
                recv_money : this.recv_money,
                where      : this.where,
                taobao     : this.taobao,
                bank_id    : this.bank_id,
                auth_code  : this.auth_code,
            }
            if(this.config.ext){
                detail.ext = this.config.ext;
            }
            return detail;
        },
        do_pay(){
            if(this.sanity_check()){
                if(!this.callback){
                    throw new Error(" NOT set Callback");
                }
                debugger
                this.creating = true;
                this.callback(this.pay_detail()).then(_=>{
                    this.creating = false;
                    debugger
                });
            }
        },
        sanity_check(){
            if (this.recv_money >= this.total_money){
                if(this.pay_type != 'cash'){
                    this.$notify({ group:"msgpad", title:"错误", text:"收取的现金多于商品总金额", type:"error"});
                    return false;
                } 
                this.pay_type = 'cash';
            }
            if(this.pay_type == 'cash'){
                if (this.total_money > 0 && this.recv_money >= this.total_money + 100) {
                    this.$notify({ group:"msgpad", title:"错误", text:"收取的现金不应多于商品总金额+100元!", type:"error"});
                    return false;
                }
                if(this.recv_money < this.total_money && this.bank_id.length != 4){
                    this.$notify({ group:"msgpad", title:"错误", text:"收取的现金不足", type:"error"});
                    return false;
                } 
            }else if(this.pay_type =='weixin'||this.pay_type =='alipay'){

                if(this.auth_code == ""){
                    this.$notify({ group:"msgpad", title:"错误", text:"请输入付款码！", type:"error"});
                    return false;
                }
            }
            return true;
        },
        prompt_input_money(){
            let self = this;
            self.prompt_dlg("收取现金收","现金",'recv',(val,dlg)=>{
                if(/^([0-9]*\.?[0-9]+)$/.test(val)){
                    val *=1;
                    if(val >=0 && val <= self.total_money){
                        return true;
                    }else{
                        dlg.set_errmsg('recv','收取的现金不应多于商品总金额');
                    }
                }
                return false
            }).then(money=>{
                self.recv_money = money*1;
            }).catch(e=>{

            })
        },
        init_dialog(){
            // debugger
            this.pay_type   = 'cash';
            this.where      = "store";
            this.bank_id    = "";
            this.auth_code  = "";
            this.recv_money = 0;
            this.taobao     = false;;
            this.err_msg    = "";
        }
    },
    components: {},
    directives: {},
    mounted :function(){},
    data () {
      return {
        pay_type   : 'cash',
        where      : 'store',
        bank_id    : "",
        auth_code  : "",
        recv_money : 0,
        creating   : false,   
        taobao     : false,
        mix_cash   : false,
        err_msg    : "ERROR",
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="css">
.v-text-field__slot > input{
    font-size: 24px !important;
}
.big_input {
    font-size: 24px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/front_sale/dialogs/dialog_user_pay.vue